export const divide = (num1: number, num2: number) => num2 === 0 ? 0 : num1 / num2;